import alt from 'components/Dispatcher';
import {browserHistory} from 'react-router';
import API from 'sources/API';

class MediaActions {
    setLoading(loading) {
        return loading;
    }
    // 更新 media 详情
    updateMedia(media) {
        return media;
    }
    // 获取 media 详情
    fetchMedia(id) {
        return id;
    }
    deleteMedia(id) {
        return id;
    }
    // 追加 MediaList
    updateMediaList(mediaList) {
        return mediaList;
    }
    // 更新全部 MediaList
    updateAllMediaList(mediaList) {
        return mediaList;
    }
    // 获取更多 MediaList
    fetchMediaList() {
        return true;
    }
    // 刷新 MediaList
    refreshMediaList() {
       return true; 
    }
    // 刷新 Media
    refreshMedia() {
       return true;
    }
    // 发布 media
    postMedia(media) {
        return media;
    }
    // 发布 media 成功
    postMediaSuccess(res) {
        if(res.status === 0) {
            browserHistory.push('/result/submit');
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    // 更新 类别
    updateCategories(categories) {
        return categories;
    }
    // 获取类别
    fetchCategories() {
        return true;
    }
    // 请求成功后统一回调
    fetchSuccess(res) {
        if(res.status === 0) {
            this[res.updateFnName](res.result);
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    deleteMediaSuccess(res) {
        if(res.status === 0){
            browserHistory.push('/medias');
        } else {
            this.fetchFailed(res);
        }
        return res;
    }
    // 请求失败后统一回调
    fetchFailed(err) {
        console.log(err);
        if(err.status === 401) {
            if(API.isWechat) {
                location.href = API.redirectWechatLogin;
            } else {
                browserHistory.push('/login');
            }
        }else{
            
        }
        return err;
    }
    // 更新 MediaList by category_id
    updateCategoryId(id) {
        return id;
    }
    // 更新 MediaList by location or category
    // category 情况只适用于分享连接数据的获取调用
    updateLocationId(id, type, cid, page) {
        return {id: id, type: type, cid: cid, page: page};
    }
    updateOffset(offset){
        return offset;
    }
    updateShareTag(){
        return true;
    }
    updateFirst(page){
        return page;
    }
}

export default alt.createActions(MediaActions);



// WEBPACK FOOTER //
// ./src/actions/MediaActions.js